<script setup>
    import { defineProps, defineEmits } from 'vue'
    import _ from "lodash";
    const { text, disabled } = defineProps(['text', 'disabled'])

    const emit = defineEmits(['click'])

    const sendEmit = () => {
        emit('click')
    }
    const onClick = _.debounce(sendEmit, 100);
</script>

<template>
    <button @click="onClick" :disabled="disabled">{{ text }}</button>
</template>

<style lang="scss" scoped>
    @import "../../../assets/scss/theme";

    button {
        border: 0;
        background:none;
        cursor:pointer;
        color: $blue_color;
        border-radius: 4px;
        @include font-size_sm;
        font-weight: 400;
        padding: 0;
        &.sm_btn {
            height: 30px;
            padding: 1px 10px;
        }
        &.black_button {
            color: $black_color;
        }
        &.gray_button {
            color: $gray_color;
        }
        &.red_button {
            color: $red_color;
        }
        &.black_button {
          color: $black_color;
        }
        &:disabled {
            cursor: default;
            color: $gray-regular_color;
            &.underline {
                border-color: $gray-regular_color;
            }
        }
    }
</style>
